import { LineItem, ShopCheckoutSideBarResponse } from 'src/Libs/shop/models'
import { ProductGeneralType } from '../types'

const CONFIGURED_SYSTEM_SUBTRACTION = 1
export const basketQuantityCounter = (items: LineItem[] | undefined): number => {
  let quantityNumber = 0
  if (items) {
    quantityNumber += items?.length
    items.forEach(item => {
      if (item.type === 'configured_system') {
        quantityNumber += item.children.length - CONFIGURED_SYSTEM_SUBTRACTION
      }
    })
  }
  return quantityNumber
}

export const getBasketNormalConfigurationIds = (cartProducts: ShopCheckoutSideBarResponse | null): string[] | undefined => {
  return cartProducts?.lineItems.filter(product => product.type === ProductGeneralType.SYSTEM_CONFIGURATOR).map(product => product.id)
}

export const getBasketQntmConfigurationIds = (cartProducts: ShopCheckoutSideBarResponse | null): string[] | undefined => {
  return cartProducts?.lineItems.filter(product => product.type === ProductGeneralType.QNTM_SYSTEM_CONFIGURATOR).map(product => product.id)
}
